module.exports = __webpack_public_path__ + "img/widderstein.79d829eb.jpg";